// removed by extract-text-webpack-plugin
module.exports = {"table__impact":"src-components-StateImpactTable----StateImpactTable-module---table__impact---IK3x-","table__footnote":"src-components-StateImpactTable----StateImpactTable-module---table__footnote---2fSKG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StateImpactTable/StateImpactTable.module.scss
// module id = 854
// module chunks = 184088790168614